export default {
  en: {
    'components.banking-details-form.label.bank-name': 'Bank Name',
    'components.banking-details-form.label.bank-address': 'Bank Address',
    'components.banking-details-form.label.iban': 'IBAN',
    'components.banking-details-form.label.amount': 'Amount',
    'components.banking-details-form.label.swift': 'SWIFT/BIC',
    'components.banking-details-form.label.account-number': 'Account Number',
    'components.banking-details-form.label.sort-code': 'Sort Code',
    'components.banking-details-form.label.reference': 'Reference',
    'components.banking-details-form.placeholder.bank-name': 'Enter Bank Name',
    'components.banking-details-form.placeholder.bank-address': 'Enter Bank Address',
    'components.banking-details-form.placeholder.iban': 'Enter IBAN',
    'components.banking-details-form.placeholder.swift': 'Enter SWIFT/BIC',
    'components.banking-details-form.placeholder.account-number': 'Enter Account Number',
    'components.banking-details-form.placeholder.reference': 'Enter Reference',
    'components.banking-details-form.error.bank-name': 'Please enter a bank name',
    'components.banking-details-form.error.bank-address': 'Please enter a bank address',
    'components.banking-details-form.error.iban': 'Please enter an IBAN',
    'components.banking-details-form.error.swift': 'Please enter a SWIFT/BIC',
    'components.banking-details-form.error.account-number': 'Please enter an Account Number',
    'components.banking-details-form.error.reference': 'Please enter a Reference',
    'components.banking-details-form.action.submit': 'Save',
    'components.banking-details-form.action.cancel': 'Cancel',
    'components.banking-details-form.server-error.default': 'An error occurred. Please try again.',
    'components.banking-details-form.server-success.default': 'Bank details saved successfully.',
  },
};
